import React, { useEffect, useState } from "react"
import { PauseCircle } from "react-feather"
import { useSelector } from "react-redux"
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap"
import { toggleTime } from "../../../api/socket/functions"
import styles from "../ScoreCounter.module.scss"
import TeamCommentModal from "./TeamCommentModal"

function TeamSection({ team, isAwayTeam, teamPausesAllowed, teamComments }) {
	const time = useSelector((state) => state.time)
	const { isPaused } = time
	const penaltiesOrEnd = useSelector((state) => state.penaltiesOrEnd)
	const spectate = localStorage.getItem("spectate")

	const teamKey = isAwayTeam ? "awayTeam" : "homeTeam"
	const [pausesUsed, setPausesUsed] = useState()
	useEffect(() => {
		setPausesUsed(JSON.parse(localStorage.getItem(`pause-${teamKey}`) ?? "0"))
	}, [time])

	const [confirmModal, setConfirmModal] = useState(false)

	const onPauseClick = () => {
		if (pausesUsed + 1 > teamPausesAllowed || isPaused)
			return setConfirmModal(true)
		addPause()
	}

	const addPause = () => {
		toggleTime({ isPaused: true, teamName: team.name })
	}

	const onContinue = () => {
		setConfirmModal(false)
		addPause()
	}

	const createAreYouSureModal = () => (
		<Modal
			isOpen={confirmModal}
			toggle={() => setConfirmModal(false)}
			className="modal-dialog-centered"
		>
			<ModalHeader toggle={() => setConfirmModal(false)}>
				{isPaused ? "Nemoguće opet pauzirat utakmicu " : "Jesi li siguran"}
			</ModalHeader>
			<ModalBody>
				{isPaused ? (
					<p>Utakmica je već pauzirana</p>
				) : (
					<>
						<p>
							Ova ekipa ({team.name}) već ima {pausesUsed} pauzi
							iskorišteno.
						</p>
						<p>
							Ako dodaš još jednu, preći će preko dopuštenih{" "}
							{teamPausesAllowed}
						</p>
					</>
				)}
			</ModalBody>
			<ModalFooter>
				{!isPaused && (
					<Button.Ripple color="danger" outline onClick={onContinue}>
						Nastavi
					</Button.Ripple>
				)}
				<Button.Ripple
					color="secondary"
					onClick={() => setConfirmModal(false)}
				>
					Odustani
				</Button.Ripple>
			</ModalFooter>
		</Modal>
	)

	return (
		<div className={`${styles.columnFlex} ${styles.teamSection}`}>
			{createAreYouSureModal()}
			<div className={styles.topTeamSection}>
				<div
					style={
						isAwayTeam
							? { paddingLeft: 16 }
							: { textAlign: "right", paddingRight: 16 }
					}
				>
					{team.name}
				</div>

				{/* <img src="https://upload.wikimedia.org/wikipedia/commons/6/6e/Football_%28soccer_ball%29.svg" /> */}
				{!penaltiesOrEnd &&
					teamPausesAllowed &&
					(spectate ? (
						<>
							<PauseCircle /> ({pausesUsed}/{teamPausesAllowed})
						</>
					) : (
						<Button.Ripple
							color="flat-primary"
							size="sm"
							onClick={onPauseClick}
						>
							<PauseCircle /> ({pausesUsed}/{teamPausesAllowed})
						</Button.Ripple>
					))}
			</div>

			{!spectate && (
				<TeamCommentModal team={team} teamComments={teamComments} />
			)}
		</div>
	)
}

export default TeamSection
